import { useSelector } from "react-redux";
import { Card, Typography, Spin } from "antd";
import { Table } from "antd";
import { useGetGrowwPositionQuery } from "../slices/gowwApiSlices";

const GrowwPositions = () => {
  const { darkmode } = useSelector((state) => state.darkmode);
  const { data, isLoading } = useGetGrowwPositionQuery();

  // Ensure positions is always an array
  const positionsData = Array.isArray(data?.positions) ? data.positions : [];

  // Columns for Ant Design Table
  const columns = [
    {
      title: "Symbol",
      dataIndex: "trading_symbol",
      key: "trading_symbol",
    },
    {
      title: "Exchange",
      dataIndex: "exchange",
      key: "exchange",
    },
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      key: "quantity",
      render: (value) => (
        <span style={{ color: value >= 0 ? "#e9c46a" : "#8e9196" }}>{value}</span>
      ),
    },
    {
      title: "Net Price",
      dataIndex: "net_price",
      key: "net_price",
      render: (value) => `₹${value}`,
    },
    {
      title: "Realised PnL",
      dataIndex: "realised_pnl",
      key: "realised_pnl",
      render: (value) => (
        <span style={{ color: value >= 0 ? "#e9c46a" : "#8e9196" }}>₹{value}</span>
      ),
    },
  ];

  // Table data source
  const tableData = positionsData.map((pos, index) => ({
    key: index,
    trading_symbol: pos.trading_symbol,
    exchange: pos.exchange,
    product: pos.product,
    quantity: parseInt(pos.quantity ?? 0, 10),
    net_price: parseFloat(pos.net_price ?? 0),
    realised_pnl: parseFloat(pos.realised_pnl ?? 0),
  }));

  return (
      <Card title="Groww Positions">
  <Table
          columns={columns}
          dataSource={tableData}
          pagination={{ pageSize: 10 }}
 scroll={{
          x: 1000, // horizontal scroll
          y: 400,  // vertical scroll
        }}          bordered
          style={{ backgroundColor: darkmode ? "#1f1f1f" : "#fff" }}
        />
    </Card>
  );
};

export default GrowwPositions;
